import { render, staticRenderFns } from "./ClientReportAccount.vue?vue&type=template&id=80775862&"
import script from "./ClientReportAccount.vue?vue&type=script&lang=js&"
export * from "./ClientReportAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports